import { FC } from 'react'
import Lamp from '@/assets/img/icons/light-on.png'
import { TypeIcon } from '@/components/Atoms/Icons/types'

const Icon: FC<TypeIcon> = ({ width = 30, height = 30 }) => {
  return (
    <img
      src={Lamp}
      alt='IconLightTower'
      width={width}
      height={height}
    />
  )
}

export default Icon
